import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

function Footer() {
    const [showCookiesConsent, setShowCookiesConsent] = useState(true); // For Cookies

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setShowCookiesConsent(false);
    };

    // Check if cookies are already accepted on mount
    useEffect(() => {
        const cookiesAccepted = localStorage.getItem("cookiesAccepted");
        if (cookiesAccepted === "true") {
            setShowCookiesConsent(false);
        }
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            {/* Site Footer - Start================================================== */}
            <footer className="footer-wrap style1 bg-aztech">
                <div className="footer-top pt-100 pb-60">
                    <div className="container">
                        <div className="row">
                            <div className="footer-widget-wrap">
                                <div className="footer-widget">
                                    <NavLink to="/" className="logo">
                                        <img src="assets/img/footer-logo.png" alt="Image" />
                                    </NavLink>
                                    <div className="newsletter-box">
                                        <p>
                                            FinestPay is trading name of Finiere Limited registered and incorporated in the UK with Companies House registration number 07461155. Finiere Limited is regulated and supervised by Financial Conduct Authority FRN 622931.
                                        </p>
                                    </div>
                                    <div className="social-box">
                                        <span>Follow us</span>
                                        <ul className="social-profile style1 list-style">
                                            <li>
                                                <NavLink target="_blank" to="https://web.facebook.com/profile.php?id=61578732036277">
                                                    <i class="fa-brands fa-facebook-f"></i>
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink target="_blank" to="https://x.com/finestpay">
                                                    <i class="fa-brands fa-x-twitter"></i>
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink target="_blank" to="https://www.instagram.com/finestpay/">
                                                    <i class="fa-brands fa-instagram"></i>
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="footer-widget">
                                    <h4 className="footer-widget-title">Quick Links</h4>
                                    <ul className="footer-menu list-style">
                                        <li>
                                            <NavLink to="/money-transfer"><i className="flaticon-next" /> Transfer Money to Nigeria</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/general-faq"><i className="flaticon-next" />FAQ's</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/contact-us"><i className="flaticon-next" />Contact Us</NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footer-widget">
                                    <h4 className="footer-widget-title">Legals</h4>
                                    <ul className="footer-menu list-style">
                                        <li>
                                            <NavLink to="/terms-and-conditions"><i className="flaticon-next" />Terms And Conditions</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/privacy-policy"><i className="flaticon-next" />Privacy Policy</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/complaints-policy"><i className="flaticon-next" />Complaints Policy</NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footer-widget">
                                    <h4 className="footer-widget-title">Get In Touch</h4>
                                    <div className="contact-item">
                                        <i className="flaticon-pin" />
                                        <h6>Address</h6>
                                        <p>30, Ridley Road, Dalston, London, United Kingdom. E8 2NR</p>
                                    </div>
                                    <div className="contact-item">
                                        <i className="flaticon-call-1" />
                                        <h6>Email</h6>
                                        <NavLink to="mailto:info@finestpay.co.uk">info@finestpay.co.uk</NavLink>
                                    </div>
                                    <div className="contact-item">
                                        <i className="flaticon-email" />
                                        <h6>Phone</h6>
                                        <NavLink to="tel:02036523240">020 3652 3240</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="footer-bottom">
                    <div className="copyright">
                        <p>
                            Copyright ©
                            <NavLink to="https://finestpay.co.uk/" target="_blank"> FinestPay</NavLink>. | Powered by <NavLink to="https://www.calyx-solutions.com/"> Calyx Solutions </NavLink>
                        </p>
                    </div>
                </div>
            </footer>
            {/* Site Footer - End================================================== */}
            {/* Back-to-top button Start */}
            <NavLink to="#" className="back-to-top" onClick={scrollToTop}>SCROLL TO TOP <i className="flaticon-next" /></NavLink>
            {/* Back-to-top button End */}


            {showCookiesConsent && (
                <div className="wrapper-cookie">
                    <div className="d-flex gap-2" style={{ alignItems: 'flex-start' }}>
                        <img src="assets/img/cookies.png" alt="cookies consent" />
                        <h5 className='text-white'>Cookies Consent</h5>
                    </div>
                    <div className="content mt-3">
                        <p className='text-white mb-3'>
                            We use cookies to improve your browsing experience and for marketing purposes.
                        </p>
                        <div>
                            <button className="btn bg-primary text-dark" onClick={acceptCookies}>
                                <span className='txt'>I understand</span>
                            </button>
                            <NavLink to="/privacy-policy" className="item ms-3" style={{ textDecoration: 'underline' }} onClick={scrollToTop}>
                                Privacy Policy
                            </NavLink>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Footer;
